export default __webpack_public_path__ + "static/calcium-3eac29fbc93f6a43c8075836038f7f3a.jpg";